export default "__VITE_ASSET__Chv19mbP__"